var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_views_hierarchy_view",
    width: 18.552,
    height: 18.551,
    viewBox: "0 0 18.552 18.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M0,900H4.638v4.638H0Z",
    transform: "translate(0 -886.087)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M900,900h4.638v4.638H900Z",
    transform: "translate(-886.086 -886.087)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M450,900h4.638v4.638H450Z",
    transform: "translate(-443.043 -886.087)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M101.546,403.865h5.411v2.319H108.5v-2.319h5.411v2.319h1.546v-3.865H108.5V400h-1.546v2.319H100v3.865h1.546Z",
    transform: "translate(-98.453 -393.816)",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M450,0h4.638V4.638H450Z",
    transform: "translate(-443.043)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHierarchy);
export default __webpack_public_path__ + "static/media/icon-hierarchy.6da01d2311efd60570cf9fd81e26a8a0.svg";
export { ForwardRef as ReactComponent };